/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import applicationStagesLabels from '../labels/applicationstages_en.json'
import docLabels from '../../documentsverification/labels/documentlabel.json';
import { getAllAdvertisementListAPI } from '../../../candidatedatamanagement/actions/candidateDataManagementAction';
import dayjs from "dayjs";
import { Modal } from 'react-bootstrap';
import TimeTableLabels from '../../../timetablemanagement/labels/timetable_en.json';
import { toUTCDate } from "../../../helpers/Datetime";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { getScheduleTypeListAPI, getInterviewPhaseDetailsAPI, interviewScheduleAPI, getInterviewScheduleListAPI, updateInterviewScheduleAPI, getEligibleCandidatesSampleFileAPI, uploadEligibleCandidatesCsvFileAPI } from "../actions/applicationStagesAction";
import { getAllExamCentersList } from '../../../venuemanagement/actions/venueManagementAction';
import TablePagination from '../../../common/components/TablePagination';
import { toastr } from "react-redux-toastr";
import "../../styles/time_table_management.css";
import "../../styles/admin_user_nav.css";
import { getPostNames } from '../../../documentsverification/actions/documentVerificationAction';
import { numberValidation } from "../../../common/constants/regex";

const InterviewPTLetterSchedule = () => {
    const { register, control, errors } = useForm({ mode: "onChange" });
    const dispatch = useDispatch();
    const [startYear, setStartYear] = useState((new Date()).getFullYear());
    const [openScheduleModal, setOpenScheduleModal] = useState(false);
    const [advtId, setAdvtId] = useState('');
    const [interviewType, setInterviewType] = useState('');
    const [interviewDate, setInterviewDate] = useState('');
    const [interviewTime, setInterviewTime] = useState('');
    const [examCenterid, setExamCenterId] = useState('');
    const [venueId, setVenueId] = useState('');
    const [interviewPhase, setInterviewPhase] = useState('');
    const [onChangeValue, setonChangeValue] = useState(false);
    const [isEditFlg, setIsEditFlg] = useState(false);
    const [interviewScheduleId, setInterviewScheduleId] = useState('');
    const [interviewCsvfile, setInterviewCsvfileFile] = useState("");
    const interviewCsvfileInputRef = useRef(null);
    const [handleOpenUploadModal, setHandleOpenUploadModal] = useState(false);
    const [scheduleData, setScheduleData] = useState({});
    const [interviewPtLetterPostId, setInterviewPtLetterPostId] = useState("");
    const [interviewSession, setInterviewSession] = useState('');
    const [interviewCommittee, setInterviewCommittee] = useState('');
    const [count, setCount] = useState('');
    const [shuffleAllRecords, setShuffleAllRecords] = useState(false);

    const { yearList, postNamesData } = useSelector((state) => state.documentVerificationReducer, shallowEqual);
    const { getAllAdvertisementList, getAllAdvertisementPageNoCounter } = useSelector((state) => state.candidateDataManagementReducer, shallowEqual)
    const { getScheduleTypeList, getInterviewPhaseDetails, getInterviewScheduleList } = useSelector((state) => state.applicationManagementReducer, shallowEqual);
    const { allExamCentersList } = useSelector((state) => state.venueManagementReducer, shallowEqual);
    let tableCounter = getAllAdvertisementPageNoCounter + 1;

    useEffect(() => {
        if (yearList && yearList.length > 0) {
            let year = yearList[0];
            setStartYear(year);
            dispatch(getAllAdvertisementListAPI(0, 10, year));
        }
        // eslint-disable-next-line
    }, [yearList]);

    const handleChildFlag = (flag) => {
        setonChangeValue(flag);
    }

    const searchAdvtData = () => {
        setonChangeValue(true);
        dispatch(getAllAdvertisementListAPI(0, 10, startYear))
    };

    const handleManageBtnClick = (advId) => {
        setOpenScheduleModal(true);
        setAdvtId(advId);
        dispatch(getInterviewScheduleListAPI(advId));
        dispatch(getScheduleTypeListAPI());
        dispatch(getAllExamCentersList());
        dispatch(getInterviewPhaseDetailsAPI())
    };

    const handleCancelClick = () => {
        setOpenScheduleModal(false);
        setAdvtId("");
        setInterviewType("");
        setInterviewDate("");
        setInterviewTime("");
        setVenueId("");
        setExamCenterId("");
        setInterviewPhase("");
        setInterviewScheduleId('');
        setInterviewSession("");
        setInterviewCommittee("");
        setCount('');
        setIsEditFlg(false);
    };

    const handleSaveBtnClick = () => {
        let interviewTimeVal = new Date(interviewTime);
        let interviewTimeData = interviewTimeVal.toLocaleTimeString(TimeTableLabels.itIT);

        let requestData = {
            "advertisementId": advtId ? advtId : '',
            "type": interviewType ? interviewType : '',
            "date": interviewDate ? interviewDate : '',
            "time": interviewTimeData ? interviewTimeData : '',
            "examCenter": examCenterid ? examCenterid : '',
            "venue": venueId ? venueId : '',
            "phase": interviewPhase ? interviewPhase : '',
            "session": interviewSession ? interviewSession : '',
            "committee": interviewCommittee ? interviewCommittee : '',
            "count": count ? count : ''
        };

        dispatch(interviewScheduleAPI(advtId, requestData));
        setInterviewType("");
        setInterviewDate("");
        setInterviewTime("");
        setVenueId("");
        setExamCenterId("");
        setInterviewPhase("");
        setInterviewScheduleId('')
        setInterviewSession("");
        setInterviewCommittee("");
        setCount('');
    };

    const formatTime = (timeString) => {
        const [hourString, minute] = timeString.split(":");
        const hour = +hourString % 24;
        return (hour % 12 || 12) + ":" + minute + " " + (hour < 12 ? "AM" : "PM");
    };

    const handleEditBtnClick = (ele) => {
        setIsEditFlg(true);
        setInterviewScheduleId(ele.id);
        if (ele && ele.type) {
            setInterviewType(ele.type);
        };

        if (ele && ele.date) {
            let date = dayjs(ele.date).toDate();
            setInterviewDate(date);
        };

        if (ele && ele.time) {
            let date = dayjs(ele.date).toDate();
            const originalDate = new Date(date);
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const formattedDate = `${monthNames[originalDate.getMonth()]} ${originalDate.getDate()} ${originalDate.getFullYear()}`;
            let finalTimeData = dayjs(formattedDate + " " + ele.time).toDate();
            setInterviewTime(finalTimeData);
        };

        if (ele && ele.examCenter) {
            setExamCenterId(ele.examCenter);
        };

        if (ele && ele.venue) {
            setVenueId(ele.venue);
        };

        if (ele && ele.phase) {
            setInterviewPhase(ele.phase);
        };

        if (ele && ele.session) {
            setInterviewSession(ele.session);
        };

        if (ele && ele.committee) {
            setInterviewCommittee(ele.committee);
        };

        if (ele && ele.count) {
            setCount(ele.count);
        };

    };


    const handleDeleteBtnClick = (ele) => {
        let advt = ele.advertisementId;
        let isRecordInUse = ele.isRecordInUse;
        toastr.confirm(isRecordInUse ? applicationStagesLabels.ALREADY_ASSIGN_MES : applicationStagesLabels.DELETE_RECORD_MES, {
            onOk: () => {
                const requestData = {
                    "id": ele.id ? ele.id : '',
                    "advertisementId": advt ? advt : '',
                    "isDeleted": true,
                    "isActive": false,
                };
                dispatch(updateInterviewScheduleAPI(advt, requestData))
                setInterviewType("");
                setInterviewDate("");
                setInterviewTime("");
                setVenueId("");
                setExamCenterId("");
                setInterviewPhase("");
                setIsEditFlg(false);
                setInterviewScheduleId('');
                setInterviewSession("");
                setInterviewCommittee("");
                setCount('');
            },
        });
    };

    const handleUpdateBtnClick = () => {
        let interviewTimeVal = new Date(interviewTime);
        let interviewTimeData = interviewTimeVal.toLocaleTimeString(TimeTableLabels.itIT);

        let requestData = {
            "id": interviewScheduleId ? interviewScheduleId : '',
            "advertisementId": advtId ? advtId : '',
            "type": interviewType ? interviewType : '',
            "date": interviewDate ? interviewDate : '',
            "time": interviewTimeData ? interviewTimeData : '',
            "examCenter": examCenterid ? examCenterid : '',
            "venue": venueId ? venueId : '',
            "phase": interviewPhase ? interviewPhase : '',
            "session": interviewSession ? interviewSession : '',
            "committee": interviewCommittee ? interviewCommittee : '',
            "count": count ? count : ''
        };
        dispatch(updateInterviewScheduleAPI(advtId, requestData))
        setIsEditFlg(false);
        setInterviewType("");
        setInterviewDate("");
        setInterviewTime("");
        setVenueId("");
        setExamCenterId("");
        setInterviewPhase("");
        setInterviewScheduleId("");
        setInterviewSession("");
        setInterviewCommittee("");
        setCount('');
    };

    // UPLOAD SECTION

    const handleUplodModalClick = (ele) => {
        setHandleOpenUploadModal(true);
        setOpenScheduleModal(false);
        // setScheduleData(ele);
        dispatch(getPostNames(advtId));
    };

    const handleOpenUploadModalCancel = () => {
        setHandleOpenUploadModal(false);
        setOpenScheduleModal(true);
        setScheduleData('');
        setInterviewCsvfileFile("");
        setInterviewPtLetterPostId("");
        setShuffleAllRecords(false);
        if (interviewCsvfileInputRef.current) {
            interviewCsvfileInputRef.current.value = "";
        }
    };

    const onInterviewLetterCsvFileChange = (event) => {
        if (event.target.files.length == 0) {
            return
        }
        setInterviewCsvfileFile(event.target.files[0])
    }

    const handleInterviewLetterCsvFileInputClick = () => {
        setInterviewCsvfileFile("");
    };

    // const handleDonwloadInterviewLetterCsvFile = () => {
    //     setInterviewCsvfileFile("");
    //     setInterviewPtLetterPostId("");
    //     if (interviewCsvfileInputRef.current) {
    //         interviewCsvfileInputRef.current.value = "";
    //     }
    // };

    const handleInterviewLetterCsvUploadClick = () => {
        let data = {};
        data.file = interviewCsvfile;
        data.action = 'upload';
        data.advertisementId = advtId ? advtId : '';
        data.shuffleAllRecords = shuffleAllRecords ? shuffleAllRecords : false;
        // data.advertisementId = scheduleData.advertisementId ? scheduleData.advertisementId : '';
        // data.intScheduleId = scheduleData.id ? scheduleData.id : '';
        data.postId = interviewPtLetterPostId ? interviewPtLetterPostId : '';
        dispatch(uploadEligibleCandidatesCsvFileAPI(data));
        setInterviewCsvfileFile("");
        setInterviewPtLetterPostId("");
        setShuffleAllRecords(false);
        if (interviewCsvfileInputRef.current) {
            interviewCsvfileInputRef.current.value = "";
        }
    };

    const handleInterviewLetterCsvFileDownload = () => {
        dispatch(getEligibleCandidatesSampleFileAPI())
    };

    const handleChange = (e) => {
        if (e.target.value === "" || numberValidation.test(e.target.value)) {
            setCount(e.target.value)
        }
    }

    return (
        <div className="border border-light text-center w-100 p-4" >
            <div className='form-group'>
                <div className='row'>
                    <div className='col-md-4 col-lg-2'>
                        <label className="fw-bold float-start">{docLabels.SELECT_YEAR}</label>
                        <div className="input-group bg-color">
                            <select
                                className="form-select bg-color"
                                name="selectedYear"
                                value={startYear}
                                onChange={(e) => {
                                    setStartYear(e.target.value);
                                }}
                            >
                                {yearList &&
                                    yearList.length > 0 &&
                                    yearList
                                        .map((element) => (
                                            <option>{element}</option>
                                        ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-auto mt-4' >
                        <button className='form-control  btn btn-primary custom_button  application_button_search  ' onClick={searchAdvtData} disabled={!startYear}><i className="fa fa-search"></i></button>
                    </div>
                </div>
            </div>
            <div>
                <table className="table table-bordered">
                    <thead className="table-primary">
                        <tr>
                            {applicationStagesLabels.allAdevertisementHeaderContent.map((ele, index) =>
                                <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody className='f12'>
                        {(getAllAdvertisementList && getAllAdvertisementList.advertisements && getAllAdvertisementList.advertisements.length > 0) ? getAllAdvertisementList.advertisements.map((ele, index) => {
                            if (ele) {
                                return (
                                    <tr key={index} >
                                        <td className="word-break" >{tableCounter++}</td>
                                        <td className="word-break" >{ele.updatedAt ? dayjs(ele.updatedAt).format(applicationStagesLabels.FULL_DATE_WITH_TIME_FOTMAT) : ""}</td>
                                        <td className="word-break" >{ele.stage}</td>
                                        <td className="word-break w10" >{ele.advertisementNo}{"/"}{ele.year}</td>
                                        <td className="word-break" >{ele.name}</td>
                                        <td className="word-break" >{ele.nameDvng} </td>
                                        <td className="word-break" >{ele.updateBy} </td>
                                        <td className="w-10 word-break text-center" >
                                            <button type="button"
                                                onClick={(e) => { handleManageBtnClick(ele.id) }}
                                                className="manageBtnCss pull-right btn btn-outline-primary  custom_button  btn-sm">
                                                {applicationStagesLabels.MANAGE}
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }
                        })
                            :
                            <tr>
                                <td colSpan="8" className="text-center">{applicationStagesLabels.NO_DATA_TO_DISPLAY}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            {(getAllAdvertisementList && getAllAdvertisementList.advertisements && getAllAdvertisementList.advertisements.length > 0) &&
                <TablePagination
                    paginationFor="all_advertisement_list_pagination"
                    rowPerPage={10}
                    year={startYear ? startYear : ''}
                    totalCount={getAllAdvertisementList && getAllAdvertisementList.count}
                    onChangeValue={onChangeValue}
                    setonChangeValue={handleChildFlag}
                />
            }

            <Modal show={openScheduleModal} backdrop='static' size="xl" onHide={() => handleCancelClick()} >
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className="logout_title">{applicationStagesLabels.INTERVIEW_PT_SCHEDULE}</Modal.Title>

                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => handleCancelClick()}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="LeftText">{applicationStagesLabels.Type}<span className="errorText">*</span></label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select bg-color"
                                            name="interviewType"
                                            value={interviewType}
                                            onInput={(e) => { setInterviewType(e.target.value) }}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">
                                                {applicationStagesLabels.COMBO_SELECT}
                                            </option>
                                            {getScheduleTypeList && getScheduleTypeList.lookupOptionDtoList && getScheduleTypeList.lookupOptionDtoList.length > 0 &&
                                                getScheduleTypeList.lookupOptionDtoList.map((ele, ind) => {
                                                    return (
                                                        <option key={ind++} value={ele.id}>
                                                            {ele.label}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    {_.get("interviewType.type", errors) === "required" && (
                                        <p className="errorText float-start">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-4">
                                    <label className="LeftText">{applicationStagesLabels.INTERVIEW_DATE}<span className="errorText">*</span></label>
                                    <Controller
                                        name="interviewDate"
                                        defaultValue={
                                            interviewDate ? dayjs(interviewDate).toDate() : ""
                                        }
                                        rules={{ required: true }}
                                        control={control}
                                        render={({ onChange, value }) => (
                                            <div className="date-picker-container">
                                                <DatePicker
                                                    selected={
                                                        interviewDate ? dayjs(interviewDate).toDate() : ""
                                                    }
                                                    onChange={(e) => {
                                                        setInterviewDate(toUTCDate(e));
                                                        onChange(toUTCDate(e));
                                                    }}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    placeholderText={applicationStagesLabels.DATE_FORMAT}
                                                    dateFormat={applicationStagesLabels.SMALL_SIZE_DATE_FORMAT}
                                                    className="form-control bg-color ps-2"
                                                    showIcon
                                                    icon={
                                                        <img src="/icons/calender.png" className="date-picker-icon"></img>
                                                    }
                                                />
                                            </div>
                                        )}
                                    />
                                    {_.get("interviewDate.type", errors) === "required" && (
                                        <p className="errorText">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-4">
                                    <label className="LeftText">{applicationStagesLabels.INTERVIEW_TIME}<span className="errorText">*</span></label>
                                    <Controller
                                        name="interviewTime"
                                        defaultValue={interviewTime ? dayjs(interviewTime).toDate() : ""}
                                        rules={{ required: true }}
                                        control={control}
                                        render={({ onChange, value }) => (
                                            <div className="date-picker-container">
                                                <DatePicker
                                                    selected={interviewTime}
                                                    onChange={(e) => {
                                                        setInterviewTime(e);
                                                        onChange(toUTCDate(e));
                                                    }}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    placeholderText="H:MM AA"
                                                    dateFormat="h:mm aa"
                                                    timeCaption="Time"
                                                    className="form-control bg-color ps-2"
                                                    showIcon
                                                    icon={
                                                        <img src="/icons/calender.png" className="date-picker-icon"></img>
                                                    }
                                                />
                                            </div>
                                        )}
                                    />
                                    {_.get("interviewTime.type", errors) === "required" && (
                                        <p className="errorText">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="LeftText">{TimeTableLabels.EXAM_CENTER}<span className="errorText">*</span></label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select bg-color"
                                            name="examCenterid"
                                            value={examCenterid}
                                            onInput={(e) => setExamCenterId(e.target.value)}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">
                                                {applicationStagesLabels.COMBO_SELECT}
                                            </option>
                                            {allExamCentersList && allExamCentersList.examCenterList && allExamCentersList.examCenterList.length > 0 && allExamCentersList.examCenterList.map((ele, i) => {
                                                return <option key={i} value={ele.id}>{ele.abbreviation} - {ele.name}</option>
                                            })}
                                        </select>
                                    </div>
                                    {_.get("examCenterid.type", errors) === "required" && (
                                        <p className="errorText">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-4">
                                    <label className="LeftText">{TimeTableLabels.SELECT_VENUE}<span className="errorText">*</span></label>
                                    <input
                                        className="form-control bg-color"
                                        type="text"
                                        name="venueId"
                                        value={venueId}
                                        onChange={(e) => setVenueId(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="LeftText">{applicationStagesLabels.INTERVIEW_PHASE}<span className="errorText">*</span></label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select bg-color"
                                            name="interviewPhase"
                                            value={interviewPhase}
                                            onInput={(e) => setInterviewPhase(e.target.value)}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">
                                                {applicationStagesLabels.COMBO_SELECT}
                                            </option>
                                            {getInterviewPhaseDetails && getInterviewPhaseDetails.lookupOptionDtoList &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.length > 0 &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.filter(item => item.type === 'phase').map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.label}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    {_.get("interviewPhase.type", errors) === "required" && (
                                        <p className="errorText float-start">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mt-2">
                                    <label className="LeftText">{applicationStagesLabels.INTERVIEW_SESSION}<span className="errorText">*</span></label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select bg-color"
                                            name="interviewSession"
                                            value={interviewSession}
                                            onInput={(e) => {
                                                setInterviewSession(e.target.value);
                                            }}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">{applicationStagesLabels.COMBO_SELECT}</option>
                                            {getInterviewPhaseDetails && getInterviewPhaseDetails.lookupOptionDtoList &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.length > 0 &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.filter(item => item.type === 'session').map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.label}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    {_.get("interviewSession.type", errors) === "required" && (
                                        <p className="errorText float-start">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-4 mt-2">
                                    <label className="LeftText">{applicationStagesLabels.INTERVIEW_COMMITTEE}<span className="errorText">*</span></label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select bg-color"
                                            name="interviewCommittee"
                                            value={interviewCommittee}
                                            onInput={(e) => {
                                                setInterviewCommittee(e.target.value);
                                            }}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">{applicationStagesLabels.COMBO_SELECT}</option>
                                            {getInterviewPhaseDetails && getInterviewPhaseDetails.lookupOptionDtoList &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.length > 0 &&
                                                getInterviewPhaseDetails.lookupOptionDtoList.filter(item => item.type === 'committee').map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.label}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    {_.get("interviewCommittee.type", errors) === "required" && (
                                        <p className="errorText float-start">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-4 mt-2">
                                    <label className="LeftText">{TimeTableLabels.CAPACITY}<span className="errorText">*</span></label>
                                    <input
                                        className="form-control bg-color"
                                        type="text"
                                        name="count"
                                        value={count}
                                        onChange={(e) => handleChange(e)}
                                        ref={register({ required: true })}
                                    />
                                    {_.get("count.type", errors) === "required" && (
                                        <p className="errorText float-start">
                                            {applicationStagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                {(isEditFlg) ?
                                    <div className="col-md-12">
                                        <button type="button" className=" btn btn-primary custom_button  float-end mt-3  " disabled={(!interviewType) || (!interviewDate) || (!interviewTime) || (!venueId) || (!examCenterid) || (!interviewPhase) || (!interviewSession) || (!interviewCommittee) || (!count)} onClick={handleUpdateBtnClick}>{applicationStagesLabels.BUTTON_UPDATE}</button>
                                    </div>
                                    :
                                    <div className="col-md-12">
                                        <button type="button" className=" btn btn-primary custom_button  float-end mt-3  " disabled={(!interviewType) || (!interviewDate) || (!interviewTime) || (!venueId) || (!examCenterid) || (!interviewPhase) || (!interviewSession) || (!interviewCommittee) || (!count)} onClick={handleSaveBtnClick}>{applicationStagesLabels.BUTTON_SAVE}</button>
                                    </div>
                                }
                            </div>
                            <hr />
                        </div>
                        <button type="button" className=" btn btn-primary custom_button  float-end mb-4 me-2  " onClick={() => handleUplodModalClick()}>{TimeTableLabels.UPLOAD}</button>
                        <div className='mt-5'>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        {applicationStagesLabels.scheduleListHeaderContent.map((ele, index) =>
                                            <th scope="col" key={index} className='text-center theadBgColor'>{ele}</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody className='f12'>
                                    {(getInterviewScheduleList && getInterviewScheduleList.interviewPtScheduleDtoList && getInterviewScheduleList.interviewPtScheduleDtoList.length > 0) ? getInterviewScheduleList.interviewPtScheduleDtoList.map((ele, index) => {
                                        if (ele) {
                                            return (
                                                <tr key={index} >
                                                    <td className="word-break text-center">{index + 1}</td>
                                                    <td className="word-break text-center">{ele.typeLabel}</td>
                                                    <td className="word-break text-center">{ele.date ? dayjs(ele.date).format(applicationStagesLabels.DATE_FORMAT) : ""}</td>
                                                    <td className="word-break text-center">{ele.time ? formatTime(ele.time) : ""}</td>
                                                    <td className="word-break text-center">{ele.examCenterName}</td>
                                                    <td className="word-break text-center">{ele.venue}</td>
                                                    <td className="word-break text-center">{ele.phaseLabel}</td>
                                                    <td className="word-break text-center">{ele.sessionLabel}</td>
                                                    <td className="word-break text-center">{ele.committeeLabel}</td>
                                                    <td className="word-break text-center">{ele.count}</td>
                                                    <td className="word-break text-center">{ele.candidateCount}</td>
                                                    <td className="w-10 word-break text-center" >
                                                        <i
                                                            role="button"
                                                            data-toggle="tooltip"
                                                            title={applicationStagesLabels.BUTTON_EDIT}
                                                            className="text-primary fa fa-edit"
                                                            onClick={() => {
                                                                handleEditBtnClick(ele);
                                                            }}
                                                        ></i>
                                                        &nbsp;&nbsp;
                                                        {/* <i
                                                        role="button"
                                                        data-toggle="tooltip"
                                                        title={
                                                            item.isActive
                                                                ? commonLabels.BUTTON_INACTIVE
                                                                : commonLabels.BUTTON_ACTIVE
                                                        }
                                                        className={
                                                            item.isActive === true
                                                                ? "text-success fa fa-toggle-on"
                                                                : "text-danger fa fa-toggle-off"
                                                        }
                                                        onClick={(e) => {
                                                            activeStageConfig(
                                                                item,
                                                                item.isActive
                                                            );
                                                        }}
                                                    ></i> */}
                                                        <i
                                                            role="button"
                                                            data-toggle="tooltip"
                                                            title={applicationStagesLabels.BUTTON_DELETE}
                                                            className="text-danger fa fa-trash"
                                                            onClick={() => {
                                                                handleDeleteBtnClick(ele);
                                                            }}
                                                        ></i>&nbsp;&nbsp;
                                                        {/* <button type="button" className=" btn btn-primary custom_button  mt-2" onClick={() => handleUplodModalClick(ele)}>{TimeTableLabels.UPLOAD}</button> */}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                        :
                                        <tr>
                                            <td colSpan="11" className="text-center">{applicationStagesLabels.NO_DATA_TO_DISPLAY}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-4" onClick={() => handleCancelClick()}>{applicationStagesLabels.BUTTON_CANCEL}</button>
                </Modal.Footer>
            </Modal>

            <Modal show={handleOpenUploadModal} backdrop='static' size="xl" onHide={() => handleOpenUploadModalCancel()} >
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className="logout_title">{TimeTableLabels.UPLOAD} {TimeTableLabels.FILE}</Modal.Title>
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => handleOpenUploadModalCancel()}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4 mt-2">
                            <label className="text-left fw-bold">{applicationStagesLabels.PostName}<span className="errorText">*</span></label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    id="interviewPtLetterPostId"
                                    name="interviewPtLetterPostId"
                                    value={interviewPtLetterPostId}
                                    onInput={(e) => {
                                        setInterviewPtLetterPostId(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">{applicationStagesLabels.COMBO_SELECT}</option>
                                    {postNamesData && postNamesData.length > 0 && postNamesData.map((element, index) =>
                                        <option key={index} value={element.id}>{element.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-4 mt-2'>
                            <label className="text-start fw-bold">{TimeTableLabels.UPLOAD} {TimeTableLabels.FILE}<span className="errorText">*</span></label><br />
                            <input
                                type="file"
                                accept='.csv'
                                name="interviewCsvfile"
                                className='bg-color'
                                onChange={(event) => onInterviewLetterCsvFileChange(event)} onClick={handleInterviewLetterCsvFileInputClick} ref={(e) => { register({ required: true })(e); interviewCsvfileInputRef.current = e; }}
                            />
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="text-left fw-bold">{applicationStagesLabels.SHUFFLE_ALL_RECORDS}</label><br />
                            <input
                                className="shuffleAllRecords"
                                type="checkbox"
                                name="shuffleAllRecords"
                                checked={shuffleAllRecords ? true : false}
                                onChange={(e) => setShuffleAllRecords(e.target.checked)}
                                ref={register({})}
                            />
                        </div>
                        <div className='col-md-4'>
                            <button
                                className="btn btn-sm btn-primary cursor-pointer ms-1 me-2 mt27"
                                onClick={handleInterviewLetterCsvUploadClick}
                                disabled={(!interviewCsvfile) || (!interviewPtLetterPostId)}
                            >
                                {applicationStagesLabels.Upload}
                            </button>
                            <button
                                className="btn btn-sm btn-primary cursor-pointer ms-1 mt27"
                                onClick={handleInterviewLetterCsvFileDownload}
                            >
                                {applicationStagesLabels.DOWNLOAD_SAMPLE_FILE}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-4" onClick={() =>
                        handleOpenUploadModalCancel()}>{applicationStagesLabels.BUTTON_CANCEL}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
};

export default InterviewPTLetterSchedule;